<!--
 * @Author: xiaokun
 * @Date: 2020-02-27 13:41:53
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-20 11:31:01
 * @Description:编辑新增常用语
 -->
<template>
  <div>
    <wraped-drawer
      size="610px"
      :title="isEdit ? '编辑常用语' : '新增常用语'"
      :confirm-text="isEdit ? '保存' : '提交'"
      :visible="visible"
      @close="onClose"
      @on-confirm="addQuestion"
    >
      <div class="question-form">
        <mk-form
          ref="questionForm"
          :model="questionForm"
          :rules="questionRules"
          label-width="120px"
          @submit.native.prevent
        >
          <!-- 商品标签 -->
          <mk-form-item
            label="商品标签："
            prop="commodityTags"
            class="commodity-tags"
          >
            <div
              class="commodity-tags-select"
            >
              <muti-select
                ref="mutiSelect"
                v-model="questionForm.commodityTags"
                :show-options="false"
                multiple
                placeholder="请选择商品标签（可多选）"
                :options-data="tagsOptions"
                :maxlength="6"
              />
              <div class="add-tags-tips">
                可以创建并选中选项中不存在的条目
              </div>
            </div>
            <span
              class="select-add-btn cursor"
              @click="handleOnSettingClick('commodityTags')"
            >新增</span>
          </mk-form-item>
          <mk-form-item
            label="常用语："
            prop="words"
          >
            <mk-input
              v-model="questionForm.words"
              maxlength="1000"
              placeholder="请输入常用语"
              width="420"
              height="100%"
              type="textarea"
              show-word-limit
              class="word"
              :autosize="{ minRows: 4}"
            ></mk-input>
          </mk-form-item>
        </mk-form>
      </div>
    </wraped-drawer>
    <common-setting-drawer
      :visible.sync="settingVisible"
      :is-setting-type="isSettingType"
      :tags-options="tagsOptions"
      @on-confirm-update-commodity-tag="onConfirmAddCommodityTag"
    />
  </div>
</template>

<script>
import WrapedDrawer from '../wraped-drawer'
import MutiSelect from '../muti-select'
import CommonSettingDrawer from '../common-setting-drawer'
export default {
  name: 'AddNewCommonLanguage',
  components: {
    WrapedDrawer,
    MutiSelect,
    CommonSettingDrawer
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 是否允许点击提交
    isSubimit: {
      type: Boolean,
      default: true
    },
    // 当前要添加到的文件夹id
    currentMenuId: {
      type: String,
      default: ''
    },
    // 是否是编辑
    isEdit: {
      type: Boolean,
      default: false
    },
    // 当前常用语的id，用于更新常用语
    currentId: {
      type: String,
      default: ''
    },
    questionForm: {
      type: Object,
      default: () => {
        return {
          words: '',
          commodityTags: []
        }
      }
    }
  },
  data () {
    return {
      questionRules: {
        words: [{ required: true, message: '请输入常用语', trigger: 'blur' }]
      },
      inputNewVal: '',
      tagsOptions: [],
      // 管理弹窗
      settingVisible: false,
      // 管理弹窗类型 关键词/商品标签
      isSettingType: ''
    }
  },
  watch: {
    visible (cur, old) {
      if (cur === true) {
        this.pCommodityTagGet()
      }
    }
  },
  methods: {
    onClose () {
      this.resetFormData()
      this.$emit('update:visible', false)
    },
    // 确认添加常用语
    addQuestion () {
      if (this.isSubimit) {
        this.$refs.questionForm.validate(async valid => {
          if (valid) {
          // 编辑常用语
            if (this.isEdit) {
              let params = {
                ...this.questionForm,
                _id: this.currentId
              }
              this.pCommonWordsPut(params)
            } else {
            // 新增常用语
              let params = {
                ...this.questionForm,
                parent: this.currentMenuId
              }
              this.pCommonWordsPost(params)
            }
          }
        })
      }
    },
    // 新建常用语
    async pCommonWordsPost (params) {
      let res = await CONVERSATIONAPIS.CommonWordsApi.pCommonWordsPost(params)
      if (res.success && res.code === 500200) {
        this.onClose()
        this.resetFormData()
        this.$message.success('添加常用语成功')
        this.$emit('on-success')
      }
    },
    // 编辑常用语
    async pCommonWordsPut (params) {
      let res = await CONVERSATIONAPIS.CommonWordsApi.pCommonWordsPut(params)
      if (res.success && res.code === 500200) {
        this.onClose()
        this.resetFormData()
        this.$message.success('编辑常用语成功')
        this.$emit('on-modify')
      }
    },
    // 重置表单
    resetFormData () {
      this.$refs.questionForm.resetFields()
    },
    // 获取全部商品标签
    async pCommodityTagGet (changeSelect) {
      let res = await CONVERSATIONAPIS.CommodityTagApi.pCommodityTagGet({})
      if (res.success) {
        this.tagsOptions = [
          ...res.data.data
        ]
        // 是否改变drawer外部下拉框的值，新增商品标签时更新
        if (changeSelect) {
          this.$emit('on-success-add-tags', res.data.data)
        }
      }
    },
    // 关键词 商品标签管理弹窗
    handleOnSettingClick (val) {
      this.isSettingType = val

      this.settingVisible = true
    },
    // 商品标签新增成功更新 商品列表
    onConfirmAddCommodityTag () {
      this.pCommodityTagGet(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.question-form {
  max-height: calc(100vh - 148px);
  padding-top: 32px;
  overflow-y: scroll;

  .add-tags-tips {
    line-height: 7px;
    margin-top: 7px;
    font-size: 12px;
    color: #888;
  }

  /deep/ .el-form-item__content {
    .el-select__input {
      margin-left: 12px;
    }

    .el-input__count {
      line-height: 21px;
      background-color: transparent;
      color: #bfbfbf;
    }

    .el-input__inner {
      padding: 8px !important;
    }

    .el-tag--small {
      margin: 4px 0 2px 6px;
    }
  }

  /deep/ .el-textarea {
    .el-textarea__inner {
      padding: 10px 10px 20px !important;
    }
  }

  /deep/ .el-tag__close {
    background-color: transparent;
  }

  /deep/ .last-el-item {
    margin-bottom: 62px;
  }

  .word {
    min-height: 120px;

    /deep/ .el-textarea__inner {
      min-height: 120px !important;
    }
  }

  .select-add-btn {
    color: #009cff;
    margin-left: 12px;
  }

  .commodity-tags {
    /deep/ .el-form-item__content {
      display: flex;
    }

    .commodity-tags-select {
      display: inline-block;
    }
  }
}
</style>
